import Grid from '@mui/material/Grid';
import ChartOptions from 'pages/BuoyData/Graph/ChartOptions';
import SideDrawer from 'pages/BuoyData/SideDrawer/SideDrawer';

// =============================================================================

// =============================================================================
export default function BuoyData() {
  return (
    <div>
      <Grid container>
        <Grid item xs={3}>
          <SideDrawer />
        </Grid>

        <Grid item xs={9}>
          <ChartOptions />
        </Grid>
      </Grid>
    </div>
  );
}
